import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { resolveScheduledTheme } from './schedule';
import { isThemeKey, type ThemeState } from './themeKeys';

const STORAGE_KEY = 'jums.theme';

const DEFAULT_STATE: ThemeState = { auto: true, manual: null };

export const themeStateAtom = atomWithStorage<ThemeState>(STORAGE_KEY, DEFAULT_STATE);

export const nowAtom = atom<Date>(new Date());

export const scheduledThemeAtom = atom((get) => resolveScheduledTheme(get(nowAtom)));

export const resolvedThemeAtom = atom((get) => {
  const state = get(themeStateAtom);
  const scheduled = get(scheduledThemeAtom);
  if (!state.auto && state.manual && isThemeKey(state.manual)) {
    return state.manual;
  }
  return scheduled;
});
